import React from 'react';

const Header = () => {
  return (
    <div
      data-testid="header-hero"
      className="w-full relative bg-cover bg-center"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/header_bg.jpg)` }}
    >
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-black/40" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 py-5 md:py-8">
        {/* Desktop: single row, logos bottom-aligned */}
        <div className="hidden md:flex items-end justify-between gap-4">
          <a href="https://www.stockergarden.com" target="_blank" rel="noopener noreferrer" className="flex-shrink-0">
            <img
              src={`${process.env.PUBLIC_URL}/stocker_logo.jpg`}
              alt="Stocker Garden"
              className="h-14 rounded"
            />
          </a>
          <div className="flex flex-col items-center gap-2">
            <img
              src={`${process.env.PUBLIC_URL}/geyser_logo_new.png`}
              alt="Geyser System"
              className="h-32"
            />
            <div className="flex items-center gap-3 text-sm text-white/90 font-medium tracking-wide">
              <span>Dal 1985</span>
              <span className="text-white/60">&middot;</span>
              <span>Alto Adige</span>
              <span className="text-white/60">&middot;</span>
              <span>Italia</span>
            </div>
          </div>
          <img src={`${process.env.PUBLIC_URL}/zanzara_icon.png`} alt="Contro Zanzare" className="h-32 flex-shrink-0" />
        </div>

        {/* Mobile: stacked center layout */}
        <div className="flex md:hidden flex-col items-center gap-3">
          <div className="flex items-center justify-between w-full">
            <a href="https://www.stockergarden.com" target="_blank" rel="noopener noreferrer">
              <img
                src={`${process.env.PUBLIC_URL}/stocker_logo.jpg`}
                alt="Stocker Garden"
                className="h-10 rounded"
              />
            </a>
            <img src={`${process.env.PUBLIC_URL}/zanzara_icon.png`} alt="Contro Zanzare" className="h-14" />
            <div className="flex items-center gap-2 text-xs text-white/80 font-medium">
              <span>Dal 1985</span>
              <span className="text-white/50">&middot;</span>
              <span>Alto Adige</span>
              <span className="text-white/50">&middot;</span>
              <span>Italia</span>
            </div>
          </div>
          <img
            src={`${process.env.PUBLIC_URL}/geyser_logo_new.png`}
            alt="Geyser System"
            className="h-16"
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
